import React from 'react';
import UpgradeCard from '@plug/components/upgrade-card';

const NavSidebarBannerSection = (): JSX.Element => {
  return <UpgradeCard />;
};

export default NavSidebarBannerSection;
